import useFingerPrintCapture from "../../../hooks/useFingerPrintCapture";
import FingerprintCapture from "./FingerprintCapture";
import FingerprintCaptureMobile from "./FingerprintCaptureMobile";

interface IFingerprintCaptureMainProps {
  isMobile: boolean;
  handleChangeTab: Function;
  companyId: string;
  roleLogged: string;
}

const FingerprintCaptureMain = ({
  isMobile,
  handleChangeTab,
  companyId,
  roleLogged,
}: IFingerprintCaptureMainProps) => {
  // custom hook
  const {
    businessAlert,
    errorMessage,
    dataParticipantState,
    isOpenModalValidateResult,
    dataATDPState,
    fingerATDP,
    validateParticipantsState,
    setMultipleParticipantInfo,
    isOpenModalErrorValidation,
    responseCapture,
    loadingFingerPrint,
    defaultCheck,
    fingerAlert,
    captureDialog,
    isramdomAvailable,
    fingerPrimary,
    fingerId,
    handPrimary,
    indexState,
    checkParticipantList,
    keyState,
    fingers,
    fingerprintJustification,
    tabstate,
    manualJustification,
    handleChangeTab: changeTab,
    handleMultipleDialogs,
    handleCaptureDialog,
    getsessionStorage,
    isButtonDisabled,
    setFingerAlert,
    clearTimer,
    resetCapture,
    setCaptureDialog,
    handleNextParticipant,
    setIsOpenModalValidateResult,
    setFingerATDP,
    setValidateParticipantsState,
    setIsOpenModalErrorValidation,
    dispatch,
    changeToManualFingerCapture,
    handleCheckbox,
    generateRandom,
    handleJustification,
    handleChangeTabPrincipal,
  } = useFingerPrintCapture({ changeTab: handleChangeTab, companyId });
  return (
    <>
      {isMobile ? (
        <FingerprintCaptureMobile
          roleLogged={roleLogged === "FNA"}
          dataParticipantState={dataParticipantState}
          isOpenModalValidateResult={isOpenModalValidateResult}
          dataATDPState={dataATDPState}
          fingerATDP={fingerATDP}
          validateParticipantsState={validateParticipantsState}
          setMultipleParticipantInfo={setMultipleParticipantInfo}
          isOpenModalErrorValidation={isOpenModalErrorValidation}
          responseCapture={responseCapture}
          loadingFingerPrint={loadingFingerPrint}
          defaultCheck={defaultCheck}
          fingerAlert={fingerAlert}
          captureDialog={captureDialog}
          isramdomAvailable={isramdomAvailable}
          fingerPrimary={fingerPrimary}
          fingerId={fingerId}
          handPrimary={handPrimary}
          tabstate={tabstate}
          indexState={indexState}
          checkParticipantList={checkParticipantList}
          keyState={keyState}
          fingers={fingers}
          fingerprintJustification={fingerprintJustification}
          manualJustification={manualJustification}
          handleChangeTab={changeTab}
          handleMultipleDialogs={handleMultipleDialogs}
          handleCaptureDialog={handleCaptureDialog}
          handleChangeTabPrincipal={handleChangeTabPrincipal}
          getsessionStorage={getsessionStorage}
          isButtonDisabled={isButtonDisabled}
          setFingerAlert={setFingerAlert}
          clearTimer={clearTimer}
          resetCapture={resetCapture}
          setCaptureDialog={setCaptureDialog}
          handleNextParticipant={handleNextParticipant}
          setIsOpenModalValidateResult={setIsOpenModalValidateResult}
          setFingerATDP={setFingerATDP}
          setValidateParticipantsState={setValidateParticipantsState}
          setIsOpenModalErrorValidation={setIsOpenModalErrorValidation}
          dispatch={dispatch}
          changeToManualFingerCapture={changeToManualFingerCapture}
          handleCheckbox={handleCheckbox}
          generateRandom={generateRandom}
          handleJustification={handleJustification}
        />
      ) : (
        <FingerprintCapture
          businessAlert={businessAlert}
          errorMessage={errorMessage}
          dataParticipantState={dataParticipantState}
          isOpenModalValidateResult={isOpenModalValidateResult}
          dataATDPState={dataATDPState}
          fingerATDP={fingerATDP}
          validateParticipantsState={validateParticipantsState}
          setMultipleParticipantInfo={setMultipleParticipantInfo}
          isOpenModalErrorValidation={isOpenModalErrorValidation}
          responseCapture={responseCapture}
          loadingFingerPrint={loadingFingerPrint}
          defaultCheck={defaultCheck}
          fingerAlert={fingerAlert}
          captureDialog={captureDialog}
          isramdomAvailable={isramdomAvailable}
          fingerPrimary={fingerPrimary}
          fingerId={fingerId}
          handPrimary={handPrimary}
          indexState={indexState}
          checkParticipantList={checkParticipantList}
          keyState={keyState}
          fingers={fingers}
          fingerprintJustification={fingerprintJustification}
          manualJustification={manualJustification}
          roleLogged={roleLogged === "FNA"}
          handleChangeTab={changeTab}
          handleMultipleDialogs={handleMultipleDialogs}
          handleCaptureDialog={handleCaptureDialog}
          getsessionStorage={getsessionStorage}
          isButtonDisabled={isButtonDisabled}
          setFingerAlert={setFingerAlert}
          clearTimer={clearTimer}
          resetCapture={resetCapture}
          setCaptureDialog={setCaptureDialog}
          handleNextParticipant={handleNextParticipant}
          setIsOpenModalValidateResult={setIsOpenModalValidateResult}
          setFingerATDP={setFingerATDP}
          setValidateParticipantsState={setValidateParticipantsState}
          setIsOpenModalErrorValidation={setIsOpenModalErrorValidation}
          dispatch={dispatch}
          changeToManualFingerCapture={changeToManualFingerCapture}
          handleCheckbox={handleCheckbox}
          generateRandom={generateRandom}
          handleJustification={handleJustification}
        />
      )}
    </>
  );
};
export { FingerprintCaptureMain };
